import { Button } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'
import { DOSSIER_FACILE_STATUS } from '@flatsy/types/Applications'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import theme from '@flatsy/core/MuiTheme/theme'
import i18n from '@flatsy/utils/translations'
import { SubBody2 } from '../../MaterialUi/Typo/Body'
import { useStyle } from './Style'
import { DossierFacileButtonProps } from './Type'

const DossierFacileButton: React.FC<DossierFacileButtonProps> = ({
  className,
  onClick,
  label,
  connected,
}): React.ReactElement => {
  const classes = useStyle()
  const isConnected = connected || connected === ''
  const renderLabel = () => {
    if (label) return label
    if (connected)
      return (
        <span>
          {i18n.t('open')}
          <span className={classes.italic}>Dossier</span>
          <span className={classes.bold}>Facile</span>
        </span>
      )
    return (
      <span>
        {i18n.t('connect_to')}
        <span className={classes.italic}>Dossier</span>
        <span className={classes.bold}>Facile</span>
      </span>
    )
  }

  const renderStatusText = () => {
    if (connected === DOSSIER_FACILE_STATUS.toProcess) {
      return i18n.t('being_processed')
    }
    if (connected === DOSSIER_FACILE_STATUS.validated) {
      return i18n.t('effective')
    }
    if (connected === DOSSIER_FACILE_STATUS.incomplete) {
      return i18n.t('incomplete')
    }

    return ''
  }

  return (
    <div className={clsx(classes.container, isConnected && classes.containerConnected)}>
      <Button
        variant="contained"
        color="primary"
        // onClick={save}
        disableElevation
        className={clsx(classes.button, isConnected && classes.buttonConnected, className)}
        onClick={onClick}
        startIcon={
          <img src={FlatsyTheme.image.FrLabel} alt="dossier-facile" className={classes.icon} />
        }
      >
        {renderLabel()}
      </Button>
      {isConnected && (
        <div className={classes.statusContainer}>
          <SubBody2 fontColor={theme.palette.secondary.dark}>{i18n.t('file_status')}</SubBody2>
          <SubBody2 fontColor={theme.palette.common.black}>{renderStatusText()}</SubBody2>
        </div>
      )}
    </div>
  )
}

export default DossierFacileButton
